// @owners { team: patients-team }
import { TypescriptUtils } from '~shared/TypescriptUtils';
import {
  CREATE_ACCOUNT,
  FERTILITY_SUPPORT,
  HOME,
  INSURANCE_FOUND,
  INSURANCE_INPUT,
  INSURANCE_INPUT_MANUAL,
  INSURANCE_INPUT_PHOTO,
  MEDICAL_INFO,
  ONBOARD_SUCCESS,
  PHI_AUTHORIZATION,
  type Route,
  VERIFY,
  WEB_LANDING_PAGE,
} from '~shared/features/onboarding/helpers/onboardingRouteHandler';

// @ts-expect-error WEB_LANDING_PAGE is excluded from onboarding routing
export const ROUTE_TO_URL: Record<Route, string> = {
  [VERIFY]: '/onboard/verify/:tempPassword',
  [INSURANCE_FOUND]: '/onboard/insurance',
  [INSURANCE_INPUT]: '/onboard/insurance-input',
  [INSURANCE_INPUT_MANUAL]: '/onboard/insurance-input-manual',
  [INSURANCE_INPUT_PHOTO]: '/onboard/insurance-input-photo',
  [MEDICAL_INFO]: '/onboard/medical-info',
  [PHI_AUTHORIZATION]: '/onboard/authorize-phi',
  [CREATE_ACCOUNT]: '/onboard/create-account',
  [FERTILITY_SUPPORT]: '/onboard/fertility-support',
  [ONBOARD_SUCCESS]: '/onboard/success',
  [HOME]: '/home',
};

export const URL_TO_ROUTE = TypescriptUtils.objectKeys(ROUTE_TO_URL).reduce<Record<string, Route>>((obj, key) => {
  const value = ROUTE_TO_URL[key];
  obj[value] = key;
  return obj;
}, {});

export function routeFromPath(path: string): Route {
  const verifyUrl = ROUTE_TO_URL[VERIFY];
  const verify = verifyUrl.substring(0, verifyUrl.indexOf(':'));
  const prescriptionTrackerVerify = '/status/';

  if (path.startsWith(verify) || path.startsWith(prescriptionTrackerVerify)) {
    return VERIFY;
  }

  if (path.startsWith('/begin/') || path.startsWith('/start/')) {
    return WEB_LANDING_PAGE;
  }

  return URL_TO_ROUTE[path];
}
